export default "__VITE_ASSET__90a6196c__"